var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGiftIncircle = function SvgIconGiftIncircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#798897"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.772,
    width: 15.06,
    height: 4.695,
    rx: 1,
    stroke: "#F1F3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.165 16.467v6.594c0 .519-.42.939-.939.939h-9.38a.939.939 0 0 1-.94-.939v-6.594M15.536 11.772V24M15.535 11.772S15.612 8 11.907 8c-.858 0-2.001.525-1.822 1.955.18 1.43 2.063 1.817 2.063 1.817",
    stroke: "#F1F3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.537 11.772S15.46 8 19.166 8c.857 0 2 .525 1.821 1.955-.18 1.43-2.063 1.817-2.063 1.817",
    stroke: "#F1F3F4"
  })));
};
export { SvgIconGiftIncircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iMTYiIGZpbGw9IiM3OTg4OTciLz4KPHJlY3QgeD0iOCIgeT0iMTEuNzcyMiIgd2lkdGg9IjE1LjA2MDIiIGhlaWdodD0iNC42OTQ1OSIgcng9IjEiIHN0cm9rZT0iI0YxRjNGNCIvPgo8cGF0aCBkPSJNMjEuMTY1NCAxNi40NjY4VjIzLjA2MTFDMjEuMTY1NCAyMy41Nzk3IDIwLjc0NSAyNCAyMC4yMjY0IDI0SDEwLjg0NTJDMTAuMzI2NiAyNCA5LjkwNjI1IDIzLjU3OTcgOS45MDYyNSAyMy4wNjExVjE2LjQ2NjgiIHN0cm9rZT0iI0YxRjNGNCIvPgo8cGF0aCBkPSJNMTUuNTM1OSAxMS43NzIyVjI0IiBzdHJva2U9IiNGMUYzRjQiLz4KPHBhdGggZD0iTTE1LjUzNTMgMTEuNzcyMkMxNS41MzUzIDExLjc3MjIgMTUuNjEyMiA4IDExLjkwNjYgOEMxMS4wNDkgOCA5LjkwNTc3IDguNTI0NTkgMTAuMDg1MiA5Ljk1NTI1QzEwLjI2NDYgMTEuMzg1OSAxMi4xNDg1IDExLjc3MjIgMTIuMTQ4NSAxMS43NzIyIiBzdHJva2U9IiNGMUYzRjQiLz4KPHBhdGggZD0iTTE1LjUzNjkgMTEuNzcyMkMxNS41MzY5IDExLjc3MjIgMTUuNDYwMSA4IDE5LjE2NTYgOEMyMC4wMjMzIDggMjEuMTY2NSA4LjUyNDU5IDIwLjk4NzEgOS45NTUyNUMyMC44MDc2IDExLjM4NTkgMTguOTIzNyAxMS43NzIyIDE4LjkyMzcgMTEuNzcyMiIgc3Ryb2tlPSIjRjFGM0Y0Ii8+Cjwvc3ZnPgo=";